import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_STUDENT_COMMENT,
  DELETE_STUDENT_COMMENT,
  GET_STUDENT_COMMENTS_FILTERS,
  GET_STUDENT_COMMENTS_GRID,
  GET_STUDENT_COMMENTS_ROW,
  UPDATE_STUDENT_COMMENT,
} from 'setup/redux/Actions/StudentComments/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* studentCommentsSaga() {
  yield takeEvery(GET_STUDENT_COMMENTS_FILTERS, fetchData)
  yield takeEvery(GET_STUDENT_COMMENTS_GRID, fetchData)
  yield takeEvery(GET_STUDENT_COMMENTS_ROW, fetchData)
  yield takeEvery(CREATE_STUDENT_COMMENT, fetchData)
  yield takeEvery(UPDATE_STUDENT_COMMENT, fetchData)
  yield takeEvery(DELETE_STUDENT_COMMENT, fetchData)
}

export default studentCommentsSaga
